import script from "./Checkout.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkout.vue?vue&type=script&setup=true&lang=js"

import "./Checkout.vue?vue&type=style&index=0&id=296c8e32&lang=css"

const __exports__ = script;

export default __exports__